import React, { useEffect, useState } from 'react';

const useAccessibleFocus = (items: any[]) => {
	const [focused, setFocused] = useState(-1);
	const refs = items.map(() => {
		return React.createRef<HTMLDivElement>();
	});

	const up = () => {
		setFocused((prev) => {
			return prev - 1 >= 0 ? prev - 1 : refs.length - 1;
		});
	};

	const down = () => {
		setFocused((prev) => {
			return prev + 1 < refs.length ? prev + 1 : 0;
		});
	};

	const handleKeyDown = (event: KeyboardEvent) => {
		event.preventDefault();

		if (event.key === 'Tab') {
			down();
		}

		if (event.key === 'ArrowDown') {
			down();
		}

		if (event.key === 'ArrowUp') {
			up();
		}
	};

	useEffect(() => {
		window.addEventListener('keydown', handleKeyDown);
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (focused >= 0 && focused < refs.length) {
			refs[focused].current?.focus();
		}
		// eslint-disable-next-line
	}, [focused]);

	return refs;
};

export default useAccessibleFocus;
